export default {"src":"/_next/static/media/CNY.857258ab.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};